import React from "react";
import { Form as FinalForm } from "react-final-form";
import setError from "./setError";
import OnBlurvalidation from "./OnBlurValidation";
import composeValidators from "utils/form";

class Form extends React.Component {
    state = {
        isLoading: false,
        initial: {},
    };
    antd
    static defaultProps = {
        hasLoading: true,
    };

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        const { onLoad, initialValues } = this.props;

        if (onLoad !== undefined) {
            this.setLoading(true);
            onLoad()
                .then((response) => {
                    this.setState({ initial: response.data, isLoading: false });
                })
                .catch((err) => {
                    this.setLoading(false);
                });
        } else if (initialValues !== undefined) {
            this.setState({ initial: initialValues });
        }
    }

    async onSubmit(values, form) {
        const { schemaValidation } = this.props,
            { mutators } = form,
            errors = composeValidators(schemaValidation, values),
            returnedErrors = {}

        if (
            Object.entries(errors).length != 0 &&
            errors.constructor === Object
        ) {
            Object.keys(errors).map((item) => {
                mutators.setError(item, errors[item] );
                returnedErrors[item] = errors[item].join(', ')
            });

            return returnedErrors
        } else {
            await this.props
                .handleSubmit(values)
                .then((res) => {
                    this.props.onSuccess != undefined &&
                        this.props.onSuccess(res);
                })
                .catch((err) => {
                    if (Array.isArray(err))
                        err.map((item) => {
                            mutators.setError(item.field,
                                item.message,
                            );
                        });

                    this.props.onError != undefined && this.props.onError(err);
                });

            return undefined;
        }
    }

    setLoading(val) {
        const { hasLoading } = this.props;

        if (hasLoading)
            this.setState({
                isLoading: val,
            });
    }

    render() {
        let { schemaValidation, fieldValidatedOnChange, validate, onSubmit, page } = this.props,
            { isLoading, initial } = this.state;

        return (
            <FinalForm
                onSubmit={onSubmit != undefined ? onSubmit : this.onSubmit}
                mutators={{ setError }}
                initialValues={initial}
                validate={validate != undefined ? validate : false}
                keepDirtyOnReinitialize={true}
                render={(dataForm) => {
                    return (
                        <form
                            onSubmit={(event) => {
                                event.preventDefault();
                                dataForm.handleSubmit();
                            }}
                        >
                            <OnBlurvalidation
                                form={dataForm.form}
                                schemaValidation={schemaValidation}
                                fieldValidatedOnChange={fieldValidatedOnChange}
                            >
                                {isLoading ? (
                                    <div tip="Twa ładowanie...">
                                        {this.props.children(dataForm)}
                                    </div>
                                ) : (
                                    this.props.children(dataForm)
                                )}
                            </OnBlurvalidation>
                        </form>
                    );
                }}
            />
        );
    }
}

export default Form;
